import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';
import { SummarySchedule } from '../_models';

@Injectable({ providedIn: 'root' })
export class SummaryScheduleService {
    constructor(private http: HttpClient) { }

    saveSchedule(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/daily-summary/schedule/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    restartSchedule(id: any): Observable<BaseResponse> {
      return this.http.put(`${environment.apiUrl}/daily-summary/schedule/restart/${id}`, {})
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }


    deleteSchedule(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/daily-summary/schedule/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    listSchedules(filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/daily-summary/schedule/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, SummarySchedule);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

}
